module.exports = __webpack_public_path__ + "static/img/293_TO8_2275_og.42d453b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/293_TO8_2275_og.jpg
// module id = JZXp
// module chunks = 0